import { BrandLogo } from './BrandLogo';
import { useTranslation } from 'react-i18next';

export function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="landing-footer">
            <div className="landing-container">
                <div className="landing-footer-top">
                    <div><BrandLogo /><p>{t('footer.desc')}</p></div>
                    <nav aria-label={t('footer.product')}><a href="#how-it-works">{t('nav.howItWorks')}</a><a href="#sample-report">{t('nav.sampleReport')}</a><a href="#faq">{t('nav.faq')}</a></nav>
                    <nav aria-label={t('footer.legal')}><a href="/privacy">{t('footer.privacy')}</a><a href="/terms">{t('footer.terms')}</a></nav>
                </div>
                <div className="landing-footer-bottom"><p>© {new Date().getFullYear()} SilverLogic LLC. {t('footer.rights')}</p><p>{t('footer.disclaimer')}</p></div>
            </div>
        </footer>
    );
}
